<template>
    <tr class="tableTr">
        <td class="" :class="{'tdGreen': checkClasses['filter_equipment']}">{{ item.equipment }}</td>
        <td class="" :class="{'tdGreen': checkClasses['filter_driver']}">{{ item['driver'] }}</td>
        <td class="" :class="{'tdGreen': checkClasses['filter_receiving_date']}">{{ item['receiving_data'] }}</td>
        <td width="130" class="center " :class="{'tdGreen': checkClasses['filter_returned']}">
            <svg-sprite v-if="item.returned" height="16" width="17" icon-id="done"></svg-sprite>
        </td>
        <td class="" :class="{'tdGreen': checkClasses['filter_returned_date']}">{{ item.returned_date }}</td>
        <td class="" :class="{'tdGreen': checkClasses['filter_notes']}">
            <span class="notes">{{ item.notes }}</span>
        </td>
        <td width="90">
            <div class="btnGroups">
                <button :disabled="getPermissionAction" type="button" @click="onEdit">
                    <svg-sprite icon-id="edit" width="18" height="18"></svg-sprite>
                </button>
                <button :disabled="getPermissionAction" type="button" @click="onRemove">
                    <svg-sprite icon-id="deleteItem" width="20" height="20"></svg-sprite>
                </button>
            </div>
        </td>
    </tr>
</template>

<script>
export default {
	name: "TableTr",
	props: {
		item: Object,
		checkClasses: Object,
		getPermissionAction: Boolean
	},
	methods: {
		onEdit() {
			this.$emit('updateEdit', this.item.id);
		},
		onRemove() {
			this.$emit('updateRemoveItem', this.item.id);
		},
	}
};
</script>
